import PropTypes from 'prop-types';
import { formatDateToString } from '@/helpers/string';
import { isDateObject } from '@/helpers/is';
import styles from './style.module.css';
import DownloadFile from '../DownloadFile';

const ViewLine = (props) => {
  const { lines, autoFit = false } = props;

  if (!lines?.length) return null;

  const formatValue = (value) => {
    if (isDateObject(value)) {
      return formatDateToString(value);
    }
    return value || '-';
  };

  return (
    <div className={`${styles.sectionContent} ${autoFit ? styles.autoFit : ''}`}>
      {lines.map((line) => (
        <div
  key={line.title}
  className={`${styles.sectionItem} ${line.fullWidth ? styles.fullWidth : ''}`}
>
          <div className={styles.sectionItemTitle}>{line.title}</div>
          <div className={styles.sectionItemValue}>
            {formatValue(line.value)}
          </div>
      {Array.isArray(line.files) && line.files.length > 0 && (
        <div className={styles.fileList}>
          {line.files.map((file, index) => (
           <DownloadFile file={file} key={index}/>
          ))}
        </div>
      )}
        </div>
      ))}
    </div>
  );
};

ViewLine.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ),
  autoFit: PropTypes.bool,
};

export default ViewLine;
